module.exports = __webpack_public_path__ + "static/img/excel.7d8f2cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/excel.png
// module id = FVKf
// module chunks = 0